// A text form of any data that is the same whenever the content is the same.
// Firebase returns a record's keys in varying order, so plain JSON comparisons
// report a change where there is none.
export const contentKey = (value) => {
  if (Array.isArray(value)) return `[${value.map(contentKey).join(',')}]`;
  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${contentKey(value[key])}`).join(',')}}`;
  }
  return JSON.stringify(value) ?? 'null';
};

export default contentKey;
